import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import SearchIcon from '@material-ui/icons/Search';
import AddIcon from '@material-ui/icons/Add';
import clsx from "clsx";
import React from "react";
import { Link } from "react-router-dom";
import { colorPicker } from "../common";
import { buttonStyles, cardStyles } from "../styles";

import "../styles/masterStyles.css";

export const PublicDeckCard = props => {
    const cards = cardStyles();
    const buttons = buttonStyles();

    const addDeck = (id) => {
        props.addDeck(id);
    }

    return (
        <Container
            disableGutters={props.disableGutters || false}
            fixed={props.fixed || false}
            maxWidth={props.maxWidth || "xs"}
            className={clsx(cards.deckContainer, colorPicker(props.deckColor))}
            style={{margin: "0 0 16px"}}
        >
            <Grid
                container={props.gridContainer || true}
                className={cards.gridContainer}
                alignContent={props.alignGrid || "stretch"}
                alignItems={props.alignGridItems || "stretch"}
                direction={props.gridDirection || "row"}
                item={props.gridItems || false}
                justify={props.justifyGrid || "flex-start"}
                lg={props.gridLG || false}
                md={props.gridMD || false}
                sm={props.gridSM || false}
                spacing={props.gridSpacing || 0}
                wrap={props.gridWrap || "wrap"}
                xl={props.gridXL || false}
                xs={props.gridXS || false}
                zeroMinWidth={props.gridZeroMinWidth || false}
            >
                <Grid item xs={12}>
                    <Typography
                        className={colorPicker(props.textColor), props.titleClass}
                        variant={props.headerSize || "h4"}
                        align={props.headerAlign || "left"}
                        display={props.display || "initial"}
                        gutterBottom={props.gutterBottom || true}
                        noWrap={props.noWrap || true}
                        paragraph={props.paragraph || true}
                        style={{
                            overflow: "hidden",
                            textOverflow: 'ellipsis',
                            whiteSpace: "nowrap"
                        }}
                    >
                        {props.deckName || "Deck #1"}
                    </Typography>
                </Grid>

                <Grid item xs={12} className="text-blue">
                    <div className="flex-row-between">
                        <div>
                            {Number(props.gameMode) != 4 ? "Open Book" : "Closed Book"}
                        </div>

                        <div>
                            {props.value ? props.value : '0'} {(props.value != 1) ? 'Questions' : 'Question'}
                        </div>
                    </div>
                </Grid>
                
                <div
                    style={{ display: "flex", justifyContent: "flex-end", width: "100%", alignItems: "center" }}
                >
                    <Link
                        to={{
                            pathname: "/viewDeck",
                            deckID: props.deckID,
                            gameMode: (typeof props.gameMode !== 'undefined' ? props.gameMode : 3)
                        }}
                    >
                        <IconButton className={buttons.deckCardButtons} aria-label="settings">
                            <SearchIcon className={buttons.deckButtons} />
                        </IconButton>
                    </Link>
                    
                    <IconButton 
                        className={buttons.deckCardButtons} 
                        aria-label="settings"
                        onClick={() => addDeck(props.deckID)}
                    >
                        <AddIcon className={buttons.deckButtons} />
                    </IconButton>
                </div>
            </Grid>
        </Container>
    );
};